import React, { useMemo } from 'react';
import {
  LuArrowDownAZ,
  LuArrowDownWideNarrow,
  LuArrowUpDown,
  LuArrowUpWideNarrow,
  LuArrowUpZA,
  LuCalendarArrowDown,
  LuCalendarArrowUp,
  LuFiles,
  LuFolderTree,
} from 'react-icons/lu';
import Dropdown from '../../layout/ReusableComponent/Dropdown/Dropdown';
import '../../layout/ReusableComponent/Dropdown/Dropdown.css';
import { useStorageBox } from '../StorageBoxContext';
import {
  STORAGE_BOX_SORT_OPTIONS,
  sortOptionValue,
} from '../utils/sortStorageBoxItems';

const SORT_OPTION_ICON_BY_VALUE = {
  'name:asc': LuArrowDownAZ,
  'name:desc': LuArrowUpZA,
  'modified:desc': LuCalendarArrowDown,
  'modified:asc': LuCalendarArrowUp,
  'size:desc': LuArrowDownWideNarrow,
  'size:asc': LuArrowUpWideNarrow,
  'type:asc': LuFolderTree,
  'type:desc': LuFiles,
};

function sortOptionIcon(field, dir) {
  const key = sortOptionValue(field, dir);
  const Icon = SORT_OPTION_ICON_BY_VALUE[key] || LuArrowUpDown;
  return <Icon aria-hidden />;
}

const SORT_DROPDOWN_OPTIONS = STORAGE_BOX_SORT_OPTIONS.map((opt) => ({
  value: sortOptionValue(opt.field, opt.dir),
  label: opt.label,
  icon: sortOptionIcon(opt.field, opt.dir),
}));

export default function StorageBoxSortSelect({ className = '' }) {
  const { sortField, sortDir, sortPreferencesLoaded, setSortOrder } = useStorageBox();
  const value = sortOptionValue(sortField, sortDir);

  const wrapClass = ['sb-drive-sort-wrap', className].filter(Boolean).join(' ');

  const options = useMemo(() => SORT_DROPDOWN_OPTIONS, []);

  const selectedOption = useMemo(
    () => options.find((opt) => opt.value === value),
    [options, value]
  );

  return (
    <div className={wrapClass}>
      <span className="sb-drive-sort-label" id="sb-drive-sort-label">
        Sort by
      </span>
      <div
        className="sb-drive-sort-dropdown sb-drive-sort-dropdown--toolbar"
        aria-labelledby="sb-drive-sort-label"
      >
        <LuArrowUpDown className="sb-drive-sort-trigger-icon" aria-hidden />
        {sortPreferencesLoaded ? (
          <Dropdown
            options={options}
            selectedOption={value}
            onSelect={(opt) => {
              if (opt?.value) setSortOrder(opt.value);
            }}
            getSelectedLabel={() => selectedOption?.label || 'Sort'}
            menuPortal
            menuPortalMinWidth={288}
            menuPortalMaxHeight={false}
            menuPortalClassName="reusable-dropdown-menu--storagebox-sort"
          />
        ) : (
          <div className="sb-drive-sort-placeholder" aria-busy="true" aria-label="Loading sort preference" />
        )}
      </div>
    </div>
  );
}
